// Copyright (c) 2017 Deere & Company

import HighOnRentalDays, {getDefaultState} from '../../shared/state/high-rental';
import actions from '../../actions-list';

const updateHighRentalDays = (state, action) =>
    HighOnRentalDays.update(state, {
        $merge: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.GET_HIGH_RENTAL_DAYS_PIN]: updateHighRentalDays
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/shared/reducers/high-rental.js